import { useIntl } from 'react-intl';

import { Text } from '@calm-web/design-system';

import messages from '@/components/emotion-detector/messages';

import { LoadingContainer } from '../styles';

export default function LoadingState() {
	const { formatMessage } = useIntl();

	return (
		<LoadingContainer>
			<Text>{formatMessage(messages.cameraRecommendationsLoading)}</Text>
		</LoadingContainer>
	);
}
